import React from 'react';
import { Card, Form, Input, Button, Select, Divider, message, Typography, Space } from 'antd';

const { Title, Paragraph } = Typography;

const Settings: React.FC = () => {
  const [form] = Form.useForm();

  const handleSave = (values: Record<string, unknown>) => {
    console.log('Settings:', values);
    message.success('设置已保存');
  };

  return (
    <div>
      <Title level={4}>系统设置</Title>
      <Paragraph type="secondary">
        配置 API 连接和 Shopify 集成参数
      </Paragraph>

      <Card title="API 配置" style={{ marginTop: 16 }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          initialValues={{
            environment: 'sandbox',
            apiBaseUrl: 'http://localhost:8069',
          }}
        >
          <Form.Item
            name="environment"
            label="环境"
            rules={[{ required: true, message: '请选择环境' }]}
          >
            <Select>
              <Select.Option value="sandbox">测试环境</Select.Option>
              <Select.Option value="production">生产环境</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="apiBaseUrl"
            label="Odoo API 地址"
            rules={[{ required: true, message: '请输入 API 地址' }]}
          >
            <Input placeholder="http://localhost:8069" />
          </Form.Item>

          <Divider />

          <Title level={5}>Shopify 配置（可选）</Title>

          <Form.Item name="shopifyShopUrl" label="Shopify 店铺 URL">
            <Input placeholder="your-store.myshopify.com" />
          </Form.Item>

          <Form.Item name="shopifyAccessToken" label="Shopify Access Token">
            <Input.Password placeholder="shpat_xxxxxxxxxxxxx" />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                保存设置
              </Button>
              <Button onClick={() => form.resetFields()}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card title="关于" style={{ marginTop: 16 }}>
        <Paragraph>
          <strong>holodao 产品中心</strong>
        </Paragraph>
        <Paragraph type="secondary">
          版本: 1.0.0
          <br />
          技术栈: React + TypeScript + Ant Design + Vite
        </Paragraph>
      </Card>
    </div>
  );
};

export default Settings;
